<template>
  <DynamicModal
    :showModal="showEditModal"
    :persistent="false"
    @clickOutside="closeModal"
    title="Edit Team"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="editTeamForm">
        <v-row class="mt-2">
          <v-col cols="12">
            <SimplePageHeader title="Team"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <UsersDropDownList
              :userId="managerId"
              :isRequired="true"
              label="Team Leader"
              @userIdChange="managerIdChangeHandler"
              @userNameChange="handleManagerNameChange"
            ></UsersDropDownList>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="teamNameValue"
              label="Team Name"
              validate-on-blur
              outlined
              :rules="[required('Name')]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-2 mb-2">
          <v-col cols="12">
            <SimplePageHeader title="Commission Override"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-if="false">
            <FormattedNumberField
              label="Base Amount"
              :value="commissionBaseAmountValue"
              prepend-inner-icon="attach_money"
              @valueChange="(newValue) => this.commissionBaseAmountValue = newValue"
            ></FormattedNumberField>
          </v-col>
          <v-col cols="12" sm="6">
            <FormattedNumberField
              label="Commission"
              :value="commissionPercentageValue"
              append-icon="percent"
              :validate-on-blur="true"
              :rules="[isValidCommission]"
              @valueChange="(newValue) => this.commissionPercentageValue = newValue"
            ></FormattedNumberField>
          </v-col>
        </v-row>
        <v-row class="mt-2 mb-2">
          <v-col cols="12">
            <SimplePageHeader title="Team Members"></SimplePageHeader>
          </v-col>
        </v-row>
        <TeamMembersCollector
          :teamMembers="teamMembers"
          @addTeamMember="addTeamMemberHandler"
          @removeMember="removeMemberHandler"
          @memberIdChange="memberIdChangeHandler"
          @roleChange="roleChangeHandler"
        ></TeamMembersCollector>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="updateTeamHandler"
          >
            Edit
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import DynamicModal from '@/components/dialogs/DynamicModal'
import { SimplePageHeader } from '@/components/pageComponents'
import { required } from '@/lib/formValidations'
import TeamMembersCollector from '@/components/teams/TeamMembersCollector'
import { mapActions } from 'vuex'
import UsersDropDownList from '@/components/users/UsersDropDownList'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    UsersDropDownList,
    TeamMembersCollector,
    DynamicModal,
    SimplePageHeader,
    FormattedNumberField
  },
  props: [
    'teamId',
    'teamName',
    'managerId',
    'commissionBaseAmount',
    'commissionPercentage',
    'teamMembers'
  ],
  data () {
    return {
      showEditModal: false
    }
  },
  computed: {
    teamNameValue: {
      get () {
        return this.teamName
      },
      set (newValue) {
        this.$emit('teamNameChange', newValue)
      }
    },
    commissionBaseAmountValue: {
      get () {
        return this.commissionBaseAmount
      },
      set (newValue) {
        this.$emit('commissionBaseAmountChange', newValue)
      }
    },
    commissionPercentageValue: {
      get () {
        return this.commissionPercentage
      },
      set (newValue) {
        this.$emit('commissionPercentageChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('teams', ['updateTeam']),
    required,
    showModal () {
      this.showEditModal = true
    },
    closeModal () {
      this.clearTeam()
      this.showEditModal = false
    },
    managerIdChangeHandler (newValue) {
      this.$emit('managerIdChange', newValue)
    },
    handleManagerNameChange (firstName, lastName) {
      this.teamNameValue = firstName + ' ' + lastName + '\'s Team'
    },
    clearTeam () {
      this.$emit('clearTeam')
      this.$refs.editTeamForm.resetValidation()
    },
    async updateTeamHandler () {
      if (this.$refs.editTeamForm.validate()) {
        await this.updateTeam({
          id: this.teamId,
          commissionBaseAmount: this.commissionBaseAmountValue,
          commissionPercentage: this.commissionPercentageValue,
          teamName: this.teamNameValue,
          managerId: this.managerId,
          teamMembers: this.teamMembers
        })
        this.clearTeam()
        this.showEditModal = false
        this.$emit('editTeam')
      }
    },
    addTeamMemberHandler () {
      this.$emit('addTeamMember')
    },
    memberIdChangeHandler ({ id, memberId }) {
      this.$emit('memberIdChange', { id, memberId })
    },
    roleChangeHandler ({ id, role }) {
      this.$emit('roleChange', { id, role })
    },
    removeMemberHandler (id) {
      this.$emit('removeMember', id)
    },
    isValidCommission () {
      if (this.commissionPercentageValue > 100 || this.commissionPercentageValue < 0) {
        return 'Commission Percent must be between 0 and 100'
      } else {
        return true
      }
    }
  }
}
</script>
